/* YAMIWARD — SHRINE LINE rail (巫女線).
   Women's cuts of the Twelve Bloodlines: fitted tees, crop hoodies, totes.
   Lists live products tagged "shrine-line" from /products.json.
   Progressive enhancement: the #shrine-line section stays hidden until the
   products exist, so an unsynced store shows nothing broken.
   Outside Japan it leaves Japan Express products out (window.YW_JAPAN, assets/storefront.js). */
(function () {
    'use strict';

    var CLAN_ORDER = ['YUKIONNA', 'ONI', 'KITSUNE', 'KODAMA', 'KAPPA', 'AMEONNA',
        'HITODAMA', 'RAIJU', 'TSUKIUSAGI', 'BAKENEKO', 'TENGU', 'RYU'];

    function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text) e.textContent = text;
        return e;
    }

    // /products.json gives tags as an array; accept the comma-separated string too
    function hasTag(p, tag) {
        var tags = p.tags || [];
        if (typeof tags === 'string') tags = tags.split(',');
        for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).trim().toLowerCase() === tag) return true;
        }
        return false;
    }

    // filter kind: the type-* tag first, then the title
    function kindOf(p) {
        if (hasTag(p, 'type-crop-hoodie')) return 'crop';
        if (hasTag(p, 'type-tote')) return 'tote';
        if (hasTag(p, 'type-tee')) return 'tee';
        // title fallback: remove after catalogue tags are live (plan Task 2.2 Step 5)
        if (p.title.indexOf('Crop Hoodie') > -1) return 'crop';
        if (p.title.indexOf('Tote') > -1) return 'tote';
        return 'tee';
    }

    // clan order: the clan-<clan> tag first, then the title prefix
    function clanRank(p) {
        for (var i = 0; i < CLAN_ORDER.length; i++) {
            if (hasTag(p, 'clan-' + CLAN_ORDER[i].toLowerCase())) return i;
        }
        // title fallback: remove after catalogue tags are live (plan Task 2.2 Step 5)
        for (var j = 0; j < CLAN_ORDER.length; j++) {
            if (p.title.indexOf(CLAN_ORDER[j]) === 0) return j;
        }
        return 99;
    }

    document.addEventListener('DOMContentLoaded', function () {
        var grid = document.getElementById('shrine-line-grid');
        var section = document.getElementById('shrine-line');
        if (!grid || !section) return;

        fetch('/products.json?limit=250')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                // Japan Express is sold in Japan only (Task 2.5): window.YW_JAPAN (assets/storefront.js) decides, the
                // same rule as japan.js and clans.js; without it (storefront.js failed) nothing is offered: fail-closed
                var items = (data.products || []).filter(function (p) {
                    return hasTag(p, 'shrine-line') && !!window.YW_JAPAN && window.YW_JAPAN.sellsHere(p);
                });
                if (!items.length) return; // line not synced yet — stay hidden

                items.sort(function (a, b) {
                    var d = clanRank(a) - clanRank(b);
                    return d !== 0 ? d : (a.title < b.title ? -1 : 1);
                });

                // filter chips: all / tees / crop hoodies / totes
                var bar = el('div', 'shrine-filter-bar');
                var kinds = [
                    { key: 'all', label: 'ALL' },
                    { key: 'tee', label: 'FITTED TEES' },
                    { key: 'crop', label: 'CROP HOODIES' },
                    { key: 'tote', label: 'TOTES' }
                ];
                var active = 'all';
                var chips = kinds.map(function (k) {
                    var c = el('button', 'shrine-chip' + (k.key === active ? ' is-active' : ''), k.label);
                    c.addEventListener('click', function () {
                        active = k.key;
                        chips.forEach(function (x) { x.classList.remove('is-active'); });
                        c.classList.add('is-active');
                        Array.prototype.forEach.call(grid.children, function (card) {
                            card.style.display = (active === 'all' || card.getAttribute('data-kind') === active) ? '' : 'none';
                        });
                    });
                    bar.appendChild(c);
                    return c;
                });
                section.querySelector('.japan-inner').insertBefore(bar, grid);

                items.forEach(function (p) {
                    var card = el('div', 'bloodline-capsule-card');
                    card.setAttribute('data-kind', kindOf(p));

                    if (p.images && p.images[0]) {
                        var img = document.createElement('img');
                        img.src = p.images[0].src;
                        img.alt = p.title;
                        img.loading = 'lazy';
                        card.appendChild(img);
                    }
                    card.appendChild(el('div', 'bloodline-capsule-kind', p.title.split(' — ')[0].toUpperCase()));

                    var sel = document.createElement('select');
                    sel.className = 'bloodline-capsule-size';
                    (p.variants || []).forEach(function (v) {
                        if (v.available === false) return; // sold out: never offered
                        var o = document.createElement('option');
                        o.value = v.id;
                        o.textContent = v.title + ' — ' + YW_MONEY.format(v.price);
                        sel.appendChild(o);
                    });
                    card.appendChild(sel);

                    var add = el('button', 'btn btn-primary bloodline-capsule-add', 'ADD TO BAG');
                    if (!sel.options.length) { sel.disabled = true; add.disabled = true; add.textContent = 'Sold out'; }
                    add.addEventListener('click', function () {
                        // assets/shell.js owns the cart: it adds, repaints the bag and opens the drawer
                        if (!window.YW_CART) { window.location.href = '/cart/add?id=' + encodeURIComponent(sel.value) + '&quantity=1'; return; }
                        add.disabled = true;
                        var settle = function (label) {
                            add.textContent = label;
                            setTimeout(function () { add.textContent = 'ADD TO BAG'; add.disabled = false; }, 1800);
                        };
                        window.YW_CART.add(Number(sel.value), 1).then(function () { settle('ADDED ✓'); }, function () { settle('TRY AGAIN'); });
                    });
                    card.appendChild(add);

                    grid.appendChild(card);
                });

                section.style.display = '';
            })
            .catch(function () { /* progressive enhancement */ });
    });
})();
